import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import './events.css';
import Preloader from '../componets/layout/preloader';
import { supabase } from '../supabaseClient';

const Events = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterStatus, setFilterStatus] = useState('');
    const [search, setSearch] = useState('');

    const initialForm = {
        title_en: "", title_ar: "", desc_en: "", desc_ar: "",
        date: "", time: "", location_en: "", location_ar: "",
        price: 0, status: "Draft", image: ""
    };
    const [form, setForm] = useState(initialForm);
    const [editForm, setEditForm] = useState(initialForm);

    const resetForm = () => {
        setForm(initialForm);
    };

    useEffect(() => {
        const getData = async () => {
            const { data, error } = await supabase.from('events').select('*');
            if (!error) setData(data);
            setLoading(false);
        };
        getData();
    }, []);

    const openEditModal = (item) => {
        setEditItem(item);
        setEditForm(item);
        setEditModalOpen(true);
    };

    const updateEvent = async (e) => {
        e.preventDefault();
        const updatePayload = {
            title_en: editForm.title_en,
            title_ar: editForm.title_ar,
            desc_en: editForm.desc_en,
            desc_ar: editForm.desc_ar,
            date: editForm.date,
            time: editForm.time,
            location_en: editForm.location_en,
            location_ar: editForm.location_ar,
            price: editForm.price,
            status: editForm.status,
            image: editForm.image
        };
        const { error } = await supabase.from('events').update(updatePayload).eq('id', editItem.id);
        if (!error) {
            setData(prev => prev.map(item => item.id === editItem.id ? { ...item, ...updatePayload } : item));
            setEditModalOpen(false);
        }
    };

    const createEvent = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('events').insert([form]).select();
        if (!error && inserted) {
            setData(prev => [...prev, inserted[0]]);
            setModalOpen(false);
            resetForm();
        }
    };

    const handleDelete = async (id) => {
        await supabase.from('events').delete().eq('id', id);
        setData(prev => prev.filter(item => item.id !== id));
    };

    const filtered = data.filter(item => {
        const matchStatus = filterStatus === '' || item.status === filterStatus;
        const matchSearch = search === '' ||
            item.title_en?.toLowerCase().includes(search.toLowerCase()) ||
            item.title_ar?.includes(search) ||
            item.location_en?.toLowerCase().includes(search.toLowerCase());
        return matchStatus && matchSearch;
    });

    return (
        <>
            <Preloader />

            {modalOpen && (
                <div className="ev-overlay">
                    <div className="ev-modal">
                        <div className="ev-modal-header">
                            <h2 className="ev-modal-title">Add New Event</h2>
                            <svg className="ev-modal-close" onClick={() => { setModalOpen(false); resetForm(); }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="ev-modal-body">
                            <form className="ev-form" onSubmit={createEvent}>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Title (EN)</label>
                                        <input required type="text" className="ev-form-input" value={form.title_en} onChange={(e) => setForm({...form, title_en: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Title (AR)</label>
                                        <input required type="text" className="ev-form-input" dir="rtl" value={form.title_ar} onChange={(e) => setForm({...form, title_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Description (EN)</label>
                                        <textarea required className="ev-form-textarea" value={form.desc_en} onChange={(e) => setForm({...form, desc_en: e.target.value})}></textarea>
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Description (AR)</label>
                                        <textarea required className="ev-form-textarea" dir="rtl" value={form.desc_ar} onChange={(e) => setForm({...form, desc_ar: e.target.value})}></textarea>
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Date</label>
                                        <input required type="date" className="ev-form-input" value={form.date} onChange={(e) => setForm({...form, date: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Time</label>
                                        <input required type="text" className="ev-form-input" placeholder="e.g., 7:00 PM" value={form.time} onChange={(e) => setForm({...form, time: e.target.value})} />
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Location (EN)</label>
                                        <input required type="text" className="ev-form-input" value={form.location_en} onChange={(e) => setForm({...form, location_en: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Location (AR)</label>
                                        <input required type="text" className="ev-form-input" dir="rtl" value={form.location_ar} onChange={(e) => setForm({...form, location_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Price ($)</label>
                                        <input required type="number" className="ev-form-input" value={form.price} onChange={(e) => setForm({...form, price: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Status</label>
                                        <select required className="ev-form-select" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                                            <option value="Draft">Draft</option>
                                            <option value="Published">Published</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="ev-form-field">
                                    <label className="ev-form-label">Event Image URL</label>
                                    <input required type="text" className="ev-form-input" placeholder="https://example.com/image.jpg" value={form.image} onChange={(e) => setForm({...form, image: e.target.value})} />
                                </div>
                                <div className="ev-form-footer">
                                    <button type="button" className="ev-cancel-btn" onClick={() => { setModalOpen(false); resetForm(); }}>Cancel</button>
                                    <button type="submit" className="ev-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Save Event
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {editModalOpen && (
                <div className="ev-overlay">
                    <div className="ev-modal">
                        <div className="ev-modal-header">
                            <h2 className="ev-modal-title">Edit Event</h2>
                            <svg className="ev-modal-close" onClick={() => setEditModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="ev-modal-body">
                            <form className="ev-form" onSubmit={updateEvent}>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Title (EN)</label>
                                        <input required type="text" className="ev-form-input" value={editForm.title_en} onChange={(e) => setEditForm({...editForm, title_en: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Title (AR)</label>
                                        <input required type="text" className="ev-form-input" dir="rtl" value={editForm.title_ar} onChange={(e) => setEditForm({...editForm, title_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Description (EN)</label>
                                        <textarea required className="ev-form-textarea" value={editForm.desc_en} onChange={(e) => setEditForm({...editForm, desc_en: e.target.value})}></textarea>
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Description (AR)</label>
                                        <textarea required className="ev-form-textarea" dir="rtl" value={editForm.desc_ar} onChange={(e) => setEditForm({...editForm, desc_ar: e.target.value})}></textarea>
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Date</label>
                                        <input required type="date" className="ev-form-input" value={editForm.date} onChange={(e) => setEditForm({...editForm, date: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Time</label>
                                        <input required type="text" className="ev-form-input" value={editForm.time} onChange={(e) => setEditForm({...editForm, time: e.target.value})} />
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Location (EN)</label>
                                        <input required type="text" className="ev-form-input" value={editForm.location_en} onChange={(e) => setEditForm({...editForm, location_en: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Location (AR)</label>
                                        <input required type="text" className="ev-form-input" dir="rtl" value={editForm.location_ar} onChange={(e) => setEditForm({...editForm, location_ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="ev-form-row">
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Price ($)</label>
                                        <input required type="number" className="ev-form-input" value={editForm.price} onChange={(e) => setEditForm({...editForm, price: e.target.value})} />
                                    </div>
                                    <div className="ev-form-field">
                                        <label className="ev-form-label">Status</label>
                                        <select required className="ev-form-select" value={editForm.status} onChange={(e) => setEditForm({...editForm, status: e.target.value})}>
                                            <option value="Draft">Draft</option>
                                            <option value="Published">Published</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="ev-form-field">
                                    <label className="ev-form-label">Event Image URL</label>
                                    <input required type="text" className="ev-form-input" value={editForm.image} onChange={(e) => setEditForm({...editForm, image: e.target.value})} />
                                </div>
                                <div className="ev-form-footer">
                                    <button type="button" className="ev-cancel-btn" onClick={() => setEditModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="ev-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Update Event
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <DashLayout title="Events Overview" active="events">
                <div className="ev-top">
                    <div className="ev-top-left">
                        <h1 className="ev-title">Events Management</h1>
                        <p className="ev-sub">Manage all your events - create, edit, and publish</p>
                    </div>
                    <button className="ev-add-btn" onClick={() => setModalOpen(true)}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        Add New Event
                    </button>
                </div>

                <div className="ev-filters">
                    <div className="ev-search-wrap">
                        <svg className="ev-search-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M13 13l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <input type="text" className="ev-search" placeholder="Search events..." value={search} onChange={e => setSearch(e.target.value)} />
                    </div>
                    <select className="ev-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="Published">Published</option>
                        <option value="Draft">Draft</option>
                    </select>
                </div>

                <div className="ev-table-wrap">
                    {loading ? (
                        <p className='loading'>Loading...</p>
                    ) : (
                        <table className="ev-table">
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Event Title (EN)</th>
                                    <th>Event Title (AR)</th>
                                    <th>Date & Time</th>
                                    <th>Location (EN)</th>
                                    <th>Location (AR)</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((item) => (
                                    <tr key={item.id}>
                                        <td><img src={item.image} alt="event" className="ev-img" /></td>
                                        <td>
                                            <p className="ev-name">{item.title_en}</p>
                                            <p className="ev-desc">{item.desc_en}</p>
                                        </td>
                                        <td dir="rtl">
                                            <p className="ev-name">{item.title_ar}</p>
                                            <p className="ev-desc">{item.desc_ar}</p>
                                        </td>
                                        <td>
                                            <p className="sec-ev-day">{item.date}</p>
                                            <p className="ev-time">{item.time}</p>
                                        </td>
                                        <td className="ev-location">{item.location_en}</td>
                                        <td className="ev-location" dir="rtl">{item.location_ar}</td>
                                        <td className="ev-price">{item.price === 0 ? 'FREE' : `$${item.price}`}</td>
                                        <td>
                                            <span className={`ev-status ev-status--${item.status === 'Published' ? 'published' : 'draft'}`}>{item.status}</span>
                                        </td>
                                        <td>
                                            <div className="ev-actions">
                                                <button className="ev-action-btn" onClick={() => openEditModal(item)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14.5 2.5a2.121 2.121 0 013 3L6 17H3v-3L14.5 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                                <button className="ev-action-btn ev-action-btn--delete" onClick={() => handleDelete(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </DashLayout>
        </>
    );
};

export default Events;